import React, { useState } from "react";
import { Button, Loading, MessageBanner } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { fetchActiveThemaImport, fetchOwnCloudStatus, startThemaImport, } from "../../api/themaImportService";
import { useThemaImportProgress } from "../../hooks/useThemaImportProgress";
import { ThemaImportProgress } from "./ThemaImportProgress";
import styles from "./themaImport.module.css";
var THEMA_IMPORT_ID_KEY = "thema-import-id";
export var ThemaImportForm = function () {
    var kyInstance = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), importId = _a[0], setImportId = _a[1];
    var _b = useQuery(["thema-owncloud-status"], function () { return fetchOwnCloudStatus(kyInstance); }, {
        retry: false,
    }), ownCloudStatus = _b.data, isCheckingConnection = _b.isLoading;
    useQuery(["thema-import-active"], function () { return fetchActiveThemaImport(kyInstance); }, {
        onSuccess: function (result) {
            if (result === null || result === void 0 ? void 0 : result.importId) {
                setImportId(result.importId);
                sessionStorage.setItem(THEMA_IMPORT_ID_KEY, result.importId);
            }
            else {
                var cachedImportId = sessionStorage.getItem(THEMA_IMPORT_ID_KEY);
                if (cachedImportId) {
                    setImportId(cachedImportId);
                }
            }
        },
    });
    var progress = useThemaImportProgress(importId);
    var isImportRunning = !!importId &&
        ((progress === null || progress === void 0 ? void 0 : progress.status) === "DOWNLOADING" || (progress === null || progress === void 0 ? void 0 : progress.status) === "RUNNING");
    var _c = useMutation({
        mutationFn: function () { return startThemaImport(kyInstance); },
        onSuccess: function (result) {
            setImportId(result.importId);
            sessionStorage.setItem(THEMA_IMPORT_ID_KEY, result.importId);
        },
    }), handleStartImport = _c.mutate, isStarting = _c.isLoading, error = _c.error;
    if (isCheckingConnection) {
        return React.createElement(Loading, null);
    }
    if (!(ownCloudStatus === null || ownCloudStatus === void 0 ? void 0 : ownCloudStatus.configured)) {
        return (React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.thema.owncloud.notConfigured" })));
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.connectionStatus },
            React.createElement(MessageBanner, { type: ownCloudStatus.connected ? "success" : "error" }, ownCloudStatus.connected ? (React.createElement(FormattedMessage, { id: "ui-br-agency.import.thema.owncloud.connected" })) : (React.createElement(FormattedMessage, { id: "ui-br-agency.import.thema.owncloud.disconnected" })))),
        React.createElement("div", { className: styles.actions },
            React.createElement(Button, { buttonStyle: "primary", onClick: function () { return handleStartImport(); }, disabled: isStarting || isImportRunning || !ownCloudStatus.connected }, formatMessage({ id: "ui-br-agency.import.thema.button.start" })),
            isStarting && React.createElement(Loading, null)),
        error && (React.createElement("div", { className: styles.errorMessage }, error instanceof Error ? error.message : "Unknown error occurred")),
        progress && React.createElement(ThemaImportProgress, { progress: progress })));
};
